function checkOffset() {
    if ($('.btn-footer-promociones').offset().top + $('.btn-footer-promociones').height() >= $('.footer-msi').offset().top - 10)
        $('.btn-footer-promociones').removeClass('fixed-btn-msi');
    if ($(document).scrollTop() + window.innerHeight < $('.footer-msi').offset().top) {
        if (!$('.btn-footer-promociones').hasClass('fixed-btn-msi')) {
            $('.btn-footer-promociones').addClass('fixed-btn-msi');
        }
    }
    //
    if ($('.btn-footer-asistencia').offset().top + $('.btn-footer-asistencia').height() >= $('.footer-msi').offset().top - 10)
        $('.btn-footer-asistencia').removeClass('fixed-btn-msi');
    if ($(document).scrollTop() + window.innerHeight < $('.footer-msi').offset().top) {
        if (!$('.btn-footer-asistencia').hasClass('fixed-btn-msi')) {
            $('.btn-footer-asistencia').addClass('fixed-btn-msi');
        }
    }

    if ($('.btn-footer-whatsapp').offset().top + $('.btn-footer-whatsapp').height() >= $('.footer-msi').offset().top - 10)
        $('.btn-footer-whatsapp').removeClass('fixed-btn-msi');
    if ($(document).scrollTop() + window.innerHeight < $('.footer-msi').offset().top) {
        if (!$('.btn-footer-whatsapp').hasClass('fixed-btn-msi')) {
            $('.btn-footer-whatsapp').addClass('fixed-btn-msi');
        }
    }
    //
    if ($('.btn-footer-chat').offset().top + $('.btn-footer-chat').height() >= $('.footer-msi').offset().top - 10)
        $('.btn-footer-chat').removeClass('fixed-btn-msi');
    if ($(document).scrollTop() + window.innerHeight < $('.footer-msi').offset().top) {
        if (!$('.btn-footer-chat').hasClass('fixed-btn-msi')) {
            $('.btn-footer-chat').addClass('fixed-btn-msi');
        }
    }
}
$(document).ready(function() {
    $('.item-menu-list').click(function() {
        $('#modalMenu').modal('hide');
    });
    $(document).scroll(function() {
        // checkOffset();
    });
});

$(document).ready(function() {
    $('#abrirMenu').click(function() {
        abrirMenu();
    });

    $('#cerrarMenu').click(function() {
        cerrarMenu();
    });

    $('#launcherchat').click(function() {
        cerrarMenu();
        zE.activate();
    });
});

function cerrarMenu() {
    $('#abrirMenu').fadeIn('fast');
    $('#cerrarMenu').fadeOut('fast');
    $('#circularMenu').removeClass("active circular-menu-active");
    $('.floating-btn').addClass("contact").removeClass("floating-btn-active");
    $('.ng-star-inserted').fadeOut('fast');
}

function abrirMenu() {
    $('#cerrarMenu').fadeIn('fast');
    $('#abrirMenu').fadeOut('fast');
    $('#circularMenu').addClass("active circular-menu-active");
    $('.floating-btn').removeClass("contact").addClass("floating-btn-active");
    $('.ng-star-inserted').fadeIn('fast');
}


// WEBPACK FOOTER //
// src/assets/js/footer.js